module.exports = __webpack_public_path__ + "static/3-fcbfaa46027d4b1a1887f63a5a5baad9.jpg";